var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.8125V12.1875C25 11.8422 24.7203 11.5625 24.375 11.5625H13.4375V10H16.25C16.9402 10 17.5 9.44023 17.5 8.75V3.75C17.5 3.05977 16.9402 2.5 16.25 2.5H8.75C8.05977 2.5 7.5 3.05977 7.5 3.75V8.75C7.5 9.44023 8.05977 10 8.75 10H11.5625V11.5625H0.625C0.279687 11.5625 0 11.8422 0 12.1875V12.8125C0 13.1578 0.279687 13.4375 0.625 13.4375H4.6875V15H2.5C1.80977 15 1.25 15.5598 1.25 16.25V21.25C1.25 21.9402 1.80977 22.5 2.5 22.5H8.75C9.44023 22.5 10 21.9402 10 21.25V16.25C10 15.5598 9.44023 15 8.75 15H6.5625V13.4375H18.4375V15H16.25C15.5598 15 15 15.5598 15 16.25V21.25C15 21.9402 15.5598 22.5 16.25 22.5H22.5C23.1902 22.5 23.75 21.9402 23.75 21.25V16.25C23.75 15.5598 23.1902 15 22.5 15H20.3125V13.4375H24.375C24.7203 13.4375 25 13.1578 25 12.8125ZM10 7.5V5H15V7.5H10ZM7.5 20H3.75V17.5H7.5V20ZM21.25 20H17.5V17.5H21.25V20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/split.6cfcc7239768be16972d4c9b64160eee.svg";
export { ForwardRef as ReactComponent };